import { login, getInfo,getAction } from '@/api/user'
import { getToken, setToken, removeToken,getAuth,setAuth,removeAuth } from '@/utils/auth'
import { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    roles: ['admin'],
    menus:[],
    staff_id:'',
    Authorisations:getAuth()||[]
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_MENUS: (state, menus) => {
    state.menus = menus
  },
  SET_STAFF_ID: (state, id) => {
    state.staff_id = id
  },
  SET_AUTH: (state, auth) => {
    state.Authorisations = auth
  },

}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        commit('SET_AVATAR', '')
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(async (response) => {
        const { data } = response

        if (!data) {
          reject('验证失败请重新登录')
        }
        // const { roles} = data
        let roles = ['admin']
        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: 角色不能为空！')
        }
        let actionRes = await getAction()
        let roleList = []
        if(actionRes.code == 200){
          roleList = actionRes.data.map(item=>item.path)
        }
        // commit('SET_ROLES', roles)
        setAuth(roleList)
        commit('SET_AUTH', roleList)
        commit('SET_MENUS', data.menu)
        commit('SET_NAME',data.staff_name)
        commit('SET_STAFF_ID',data.staff_id)
        
        resolve(data.menu)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      removeToken() // must remove  token  first
      removeAuth() // must remove  token  first
      resetRouter()
      commit('RESET_STATE')
      resolve()
      // logout(state.token).then(() => {
      //   removeToken() // must remove  token  first
      //   resetRouter()
      //   commit('RESET_STATE')
      //   resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      removeAuth()
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

